<div class="notas-fiscais">
    @if (pedido?.notasFiscais?.length <= 0) {
        <div class="vazio">
            {{ 'componente.nota-fiscal.vazio' | translate}}
        </div>
    }
    @if (pedido?.notasFiscais?.length > 1 && !_visaoPDF) {
        <section class="d-flex flex-wrap striped notas">
            <header>
                <div class="col">{{ 'componente.nota-fiscal.tabela.nota.coluna' | translate}}</div>
                <div class="col text-center">{{ 'componente.nota-fiscal.tabela.nota.ver' | translate}}</div>
                @if (is_seller) {
                    <div class="col text-center">{{ 'componente.nota-fiscal.tabela.nota.baixar' | translate}}</div>
                }
                @if (showTransportadora) {
                    <div class="col text-center">{{ 'componente.nota-fiscal.tabela.nota.transportadora' | translate}}</div>
                }
                @if (is_seller) {
                    <div class="col text-center">{{ 'componente.nota-fiscal.tabela.nota.excluir.titulo' | translate}}</div>
                }
            </header>
            <ng-scrollbar class="corpo">
                @for (nota of notasFiscaisOrdenadas; track nota) {
                    <div class="linha">
                        <div class="col">{{nota.numero}}</div>
                        <div class="col text-center">
                            <i class="fa fa-search cursor-pointer" (click)="selecionarNota(nota)"></i>
                        </div>
                        @if (is_seller) {
                            <div class="col text-center">
                                <i class="fa fa-download cursor-pointer" (click)="baixarNota(nota.url)"></i>
                            </div>
                        }
                        @if (showTransportadora) {
                            <div class="col text-center">
                                <i class="fa fa-truck cursor-pointer" (click)="modalTransportadoraAbrir(nota, false)"
                                    [ngClass]="{ 'text-danger': !nota.shipping_company_tracking_code }"></i>
                            </div>
                        }
                        @if (is_seller) {
                            <div class="col text-center">
                                <i class="fa fa-times text-danger cursor-pointer" (click)="_excluirNota(nota.url)"></i>
                            </div>
                        }
                    </div>
                }
            </ng-scrollbar>
        </section>
    }
    @if (pedido?.notasFiscais?.length >= 1 && _visaoPDF && pdfSrc) {
        <div>
            <div class="voltar-remover">
                @if (showTransportadora && pedido?.notasFiscais?.length === 1) {
                    <a (click)="modalTransportadoraAbrir(pedido.notasFiscais[0], false)" [ngClass]="{ 'text-danger': !pedido.notasFiscais[0].shipping_company_tracking_code }">{{'componente.nota-fiscal.tabela.nota.transportadora' | translate}}</a>
                }
                <a (click)="baixarNota(pdfSrc)">{{ 'elemento.generico-botao.baixar' | translate }}</a>
                @if (is_central || is_seller) {
                    <a (click)="_excluirNota(pdfSrc)">{{ 'elemento.generico-botao.remover' | translate }}</a>
                }
                @if (pedido?.notasFiscais?.length > 1) {
                    <a (click)="visaoPDF=false">{{ 'elemento.generico-botao.voltar' | translate }}</a>
                }
            </div>
            <pdf-viewer [src]="pdfSrc" class="pdf-viewer {{pdf_viewer_class}}" [render-text]="true"></pdf-viewer>
        </div>
    }
</div>
